<template>
    <div class="main-header-navigation">
        <!-- Mobile -->
        <v-list v-if="mobile" class="main-header-navigation__mobile">
            <template v-for="item in items">
                <template v-if="item.children && item.children.length">
                    <v-list-group :key="item.title">
                        <template #activator>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="child in item.children" :key="child.title" :to="child.path">
                            {{ child.title }}
                        </v-list-item>
                    </v-list-group>
                </template>
                <template v-else>
                    <v-list-item :to="item.path" :key="item.title">
                        {{ item.title }}
                    </v-list-item>
                </template>
            </template>
        </v-list>

        <!-- Desktop -->
        <v-container v-else class="container--sm">
            <v-hover v-slot="{ hover }">
                <ul class="main-header-navigation__pc" @mouseenter="onMouseEnter">
                    <li v-for="item in items" :key="item.title">
                        <router-link :to="item.path">{{ item.title }}</router-link>

                        <template v-if="item.children && item.children.length">
                            <v-fade-transition>
                                <v-list v-show="hover" color="transparent" ref="dropdownLists">
                                    <v-list-item v-for="child in item.children" :key="child.title" :to="child.path">
                                        {{ child.title }}
                                    </v-list-item>
                                </v-list>
                            </v-fade-transition>
                        </template>
                    </li>

                    <v-fade-transition>
                        <div v-show="hover" class="navigation-bg" :style="{ height: `${maxDropdownHeight}px` }"></div>
                    </v-fade-transition>
                </ul>
            </v-hover>
        </v-container>
    </div>
</template>

<script>
export default {
    props: {
        mobile: { type: Boolean, default: false },
    },
    data() {
        return {
            categories: [],
            maxDropdownHeight: 200,
        };
    },
    computed: {
        items() {
            const categoryChildren = this.categories.map((category) => ({
                title: category.name,
                path: `/shop?category=${category.code}`,
            }));
            return [
                {
                    title: "회사소개",
                    path: "/about",
                    children: [
                        {
                            title: "회사소개",
                            path: "/about",
                        },
                        {
                            title: "연혁",
                            path: "/about/history",
                        },
                        {
                            title: "오시는 길",
                            path: "/about/location",
                        },
                    ],
                },
                {
                    title: "파트너안내",
                    path: "/partner",
                },
                {
                    title: "제품소개",
                    path: "/shop",
                    children: categoryChildren,
                },
                {
                    title: "공지사항",
                    path: "/center/notice",
                },
                {
                    title: "문의",
                    path: "/mypage/questions",
                },
            ];
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                await this.getCategories();
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
        onMouseEnter() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.calculateMaxDropdownHeight();
                }, 50);
            });
        },
        calculateMaxDropdownHeight() {
            if (!this.$refs.dropdownLists) return;

            let maxHeight = 0;
            const lists = Array.isArray(this.$refs.dropdownLists) ? this.$refs.dropdownLists : [this.$refs.dropdownLists];

            lists.forEach((list) => {
                if (list && list.$el) {
                    const height = list.$el.offsetHeight;
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                }
            });

            if (maxHeight > 0) {
                this.maxDropdownHeight = maxHeight;
            }
        },
        getCategories() {
            return new Promise(async (resolve, reject) => {
                try {
                    var res = await this.$http.get("/api/v1/shop/categories");

                    this.categories = res.data.categories;
                    this.$nextTick(() => {
                        const HTML = document.querySelector("html");
                        var header = document.querySelector(".header");
                        var hamburgerBtn = document.querySelector(".mobile-hamburger__btn");
                        var mobileSidebarLink = document.querySelectorAll(".mobile-sidebar__link");
                        var mobileCategory = document.querySelectorAll(".mobile-category__list-link[data-toggle]");
                        var mobileCategoryLink = document.querySelectorAll("a.mobile-category__list-link");
                        var mobileCategoryLinkA = document.querySelectorAll("span.mobile-category__list-link >a");

                        mobileSidebarLink.forEach((element) => {
                            element.addEventListener("click", hamburgerCreate);
                        });
                        mobileCategory.forEach((element) => {
                            element.addEventListener("click", function () {
                                let state = this.getAttribute("data-toggle");
                                if (state === "closed") {
                                    this.setAttribute("data-toggle", "opened");
                                } else {
                                    this.setAttribute("data-toggle", "closed");
                                }
                            });
                        });
                        mobileCategoryLink.forEach((element) => {
                            element.addEventListener("click", hamburgerCreate);
                        });
                        mobileCategoryLinkA.forEach((element) => {
                            element.addEventListener("click", hamburgerCreate);
                        });

                        // Mobile Hamburger
                        function hamburgerCreate() {
                            let attr = header.getAttribute("data-dimmed");
                            if (attr !== null) {
                                hamburgerBtn.setAttribute("aria-pressed", "false");
                                header.setAttribute("data-sidebar", "closed");
                                header.setAttribute("data-dimmed", "closed");
                                mobileCategory.forEach((element) => {
                                    element.setAttribute("data-toggle", "closed");
                                });
                            }
                        }
                    });

                    resolve();
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.main-header-navigation {
    width: 100%;
    .container {
        position: relative;
    }
    &__mobile {
        padding: 0;
        > .v-list-group > ::v-deep(.v-list-group__header),
        > .v-list-item {
            padding: 0 12px;
            background: var(--v-grey-lighten5);
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        ::v-deep(.v-list-item__title),
        .v-list-item {
            font-size: 14px;
            color: var(--v-grey-darken4);
        }
        ::v-deep(.v-list-group__items) {
            > .v-list-item {
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            }
        }
    }
    &__pc {
        width: 100%;
        display: flex;
        justify-content: space-between;
        > li {
            position: relative;
            > a {
                display: flex;
                align-items: center;
                padding: 0 10px;
                height: var(--header-foot-height);
                font-weight: 500;
                transition: color 0.1s ease-in-out;
            }
            &:hover {
                > a {
                    color: var(--v-primary-base);
                }
            }
            > .v-list {
                position: absolute;
                left: 50%;
                transform: translate(-50%, 100%);
                bottom: 0;
                width: 200px;
                padding: 24px 0;
                > .v-list-item {
                    padding: 8px 24px;
                    min-height: initial;
                    justify-content: center;
                    text-align: center;
                    line-height: 1.35;
                    color: var(--v-grey-lighten1) !important;
                    transition: color 0.1s ease-in-out;
                    &::before {
                        display: none;
                    }
                    &:hover {
                        color: var(--v-grey-darken4) !important;
                    }
                }
            }
        }
        .navigation-bg {
            position: absolute;
            bottom: 0;
            left: -50vw;
            background-color: white;
            transform: translateY(100%);
            width: 150vw;
            transition: height 0.2s ease;
            z-index: -1;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
    }
}
</style>